import { IconProps, IconType } from '@/common/icons/types.ts'
import { cn } from '@/common/utilities.ts'

export const Burger5Icon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-burger-menu-5', type, className)} />
}
